const icons = {
  pokemon_trainer: "person-check-fill",
  first_binder: "journal-album",
  binder_builder: "collection-fill",
  fossil_finder: "search",
  match_radar: "radar",
  first_meetup: "people-fill"
};
const aliases = { binder: "journal-album", people: "people-fill", star: "star-fill" };
export const badgeIcon = badge => icons[badge.code] || aliases[badge.icon_key] || "award-fill";
